import { render } from "./Resume3.vue?vue&type=template&id=ce7f0d0e&scoped=true"
import script from "./Resume3.vue?vue&type=script&lang=js"
export * from "./Resume3.vue?vue&type=script&lang=js"

import "./Resume3.vue?vue&type=style&index=0&id=ce7f0d0e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ce7f0d0e"

export default script